import PublicPageFooter from './PublicPageFooter';
export default PublicPageFooter;